export default "__VITE_ASSET__e58de5c3__"